/** Every route the feature owns, so a path is written once and linked to by name. */
const BUILDER_PATH = '/system/media-package-builder';

export const MEDIA_PACKAGE_BUILDER_ROUTES = {
  builder: '/marketing/media-package-builder',
  assets: `${BUILDER_PATH}/assets`,
  newAsset: `${BUILDER_PATH}/assets/new`,
  asset: (assetId: string) => `${BUILDER_PATH}/assets/${assetId}`,
  packages: `${BUILDER_PATH}/packages`,
  package: (mediaPackageId: string) => `${BUILDER_PATH}/packages/${mediaPackageId}`,
};

export const ROWS_PER_PAGE_OPTIONS = [25, 50, 100];

export const DEFAULT_ROWS_PER_PAGE = ROWS_PER_PAGE_OPTIONS[1];

/** Long enough that a search is not fired on every keystroke, short enough to feel immediate. */
export const SEARCH_DEBOUNCE_MS = 300;

/** Enough to hold the whole catalogue in one call, for the asset picker. */
export const CATALOGUE_LIMIT = 500;
